<ion-app>
  <ion-router-outlet [animated]="false"></ion-router-outlet>
</ion-app>